import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
  gitflicAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { GitflicPipelinesApiClient, gitflicPipelinesApiRef } from '../api';

export const gitflicPipelinesApiExtension = ApiBlueprint.make({
  name: 'gitflic-pipelines',
  params: defineParams =>
    defineParams({
      api: gitflicPipelinesApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        gitflicAuthApi: gitflicAuthApiRef,
      },
      factory: ({ discoveryApi, fetchApi, gitflicAuthApi }) =>
        new GitflicPipelinesApiClient({
          discoveryApi,
          fetchApi,
          gitflicAuthApi,
        }),
    }),
});
